
var finansudd = finansudd || {};

finansudd.overlay = new function () {

    var self = this;


    this.toggleOverlay = function () {


        $('body').on('click', '.blue-overlay', function () {
            $('body').removeClass('open-overlay').removeClass('transparent-overlay'); // Close overlay
        });

    };

    // Remove classes when the overlay is clicked
    this.removeActive = function (selector, itemClass) {
        var $selector = selector ? $(selector) : null,
            itemClass = itemClass ? itemClass : '';

        if ($selector != null) {
            $('body').on('click', '.blue-overlay', function () {
                $selector.removeClass(itemClass);
            });
        }
    }

    this.setRteLinkOverlay = function () {

        $('.rte').on('click', 'a[target="_overlay"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.overlayLink(this);
        });

        $('.media').on('click', 'a[target="_overlay"]', function (e) {
            e.preventDefault();
            e.stopPropagation();
            self.overlayLink(this);
        });
    }

    this.overlayLink = function (item) {
        var url = $(item).attr("href");
        var target = $(item).attr("target");
        if (target == "_overlay") {
            if (url.search('http') != 0 || url.search('https') != 0) {
                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    contentType: "html/text; charset=utf-8",
                    dataType: 'html',
                    success: function (data) {
                        data = '<div class="data-container">' + data + '</div>';
                        self.setOverlay(data, url);
                    },
                    error: function (data, errorThrown) {
                        console.log(errorThrown);
                    }
                });
            }
            else {

                var data = '<iframe src="' + url + '" frameborder="0"></iframe>';
                self.setOverlay(data);
            }
        }
    }

    this.setOverlay = function (data) {
        $('body').addClass('overlay-on');
        var html = '<div class="overlay">';
        html += '<div class="overlay-content"><div class="overlay-close">&times;</div>' + data + '</div>';
        html += '</div>';

        $('body').prepend(html).hide().fadeIn("fast");

        $('.overlay-close').on('click', function (e) {
            $('.overlay').remove();
            $('body').removeClass('overlay-on');
        });
        novicell.responsiveImages.init();

    }
};